import { useState } from 'react';
import { Loader2, RefreshCw } from 'lucide-react';
import { useQuery } from '@tanstack/react-query';
import { dbClient, normalizeRpcResponse } from '@/services/db-client';

interface LeadRow {
  id: string;
  email: string;
  phone: string | null;
  topic: string;
  season: number;
  is_test: boolean;
  consented_at: string;
  created_at: string;
}

export function BluefinLeadsPanel() {
  const [search, setSearch] = useState('');
  const { data, isLoading, refetch, isFetching } = useQuery({
    queryKey: ['admin', 'bluefin-leads', search],
    queryFn: async () => {
      const { data: rows, error } = await dbClient.rpc<LeadRow>('admin_bluefin_leads_list', {
        p_search: search.trim() || null,
        p_limit: 200,
      });
      if (error) throw new Error(error.message);
      return normalizeRpcResponse(rows) as LeadRow[];
    },
    staleTime: 30_000,
  });

  return (
    <div className="space-y-4">
      <p className="text-sm text-muted-foreground">
        Lista de espera 2027. No hay cobro. Los emails de prueba (`soporte+qa-atun-`) quedan marcados.
      </p>
      <div className="flex gap-2">
        <input
          className="rounded-md border border-border bg-background px-2 py-1 text-sm"
          placeholder="Buscar email o teléfono"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <button type="button" onClick={() => refetch()} className="text-sm text-muted-foreground">
          <RefreshCw size={14} className={isFetching ? 'animate-spin' : ''} />
        </button>
      </div>
      {isLoading ? (
        <Loader2 className="animate-spin" size={18} />
      ) : !data?.length ? (
        <p className="text-sm text-muted-foreground">Todavía no hay avisos.</p>
      ) : (
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-muted-foreground">
              <th className="py-1">Email</th>
              <th>Teléfono</th>
              <th>Temporada</th>
              <th>Alta</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row) => (
              <tr key={row.id} className="border-t border-border">
                <td className="py-1.5">
                  {row.email}
                  {row.is_test ? (
                    <span className="ml-2 text-xs text-amber-500">test</span>
                  ) : null}
                </td>
                <td>{row.phone || '—'}</td>
                <td>{row.season}</td>
                <td>{new Date(row.created_at).toLocaleString('es-ES')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
